import * as routes from './routes';

export default [
    {url: routes.commonNotificationsRoute, method: 'get'},
    {url: routes.commonNotificationsRoute, method: 'patch'},
    {url: routes.commonFiltersRoute, method: 'get'},
    {url: routes.carsSmsRoute, method: 'get'},
    {url: routes.carsSmsRoute, method: 'put'},
    {url: routes.commonReadAddressRoute, method: 'get'},
    {url: routes.reportsPendingReportsRoute, method: 'get'},
    {url: routes.mapCurrentRouteRoute, method: 'get'},
];
